import { useEffect, useState } from 'react'
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import UserPanel from '../user-panel/UserPanel';
import './Header.scss';
import { Template } from 'devextreme-react/core/template';
// import { ThemeSwitcher } from '../theme-switcher/ThemeSwitcher';
import type { HeaderProps } from '../../types';

import Box from '@mui/material/Box'
// import TextField from '@mui/material/TextField'

import { CardContent, Chip, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material';
// import MuiAutocomplete, { AutocompleteRenderInputParams } from '@mui/material/Autocomplete'
// import { styled, useTheme } from '@mui/material/styles'

// import AutocompleteComponent from './autocomplete/Autocomplete';

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
// import DialogContentText from '@mui/material/DialogContentText'
// import DialogActions from '@mui/material/DialogActions'
import { Controller, useForm } from 'react-hook-form';
import axios from 'axios';
import apiUrl from '../../configs/constant';
import Swal from 'sweetalert2';

export default function Header({ menuToggleEnabled, title, toggleMenu }: HeaderProps) {
  const userData = JSON.parse(localStorage.getItem('user')!)
  // const user = userData.data.userLoginResponse
  const token = userData.data.token

  const cabang = JSON.parse(localStorage.getItem('cabang')!)
  const kolam = JSON.parse(localStorage.getItem('kolam')!)

  const [openDialog, setOpenDialog] = useState<boolean>(false)
  const [listCabang, setListCabang] = useState<any[]>([])

  const [openDialogKolam, setOpenDialogKolam] = useState<boolean>(false)
  const [listKolam, setListKolam] = useState<any[]>([])

  const getDataKolam = (cabangId: number) => {
    const url = apiUrl.apiUrl + `/api/v1/tambaq/master/kolam/list-combo/${cabangId}`;
    axios
      .get(url, {
        params: { tambakId: cabangId },
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(response => {
        if (response.data.success) {
          const data = response.data.data
          setListKolam(data)
        } else {
          Swal.fire({
            title: 'Pemberitahuan',
            text: response.data.message,
            icon: 'error'
          })
        }
      })
      .catch(() => {
        Swal.fire({
          title: 'Pemberitahuan',
          text: 'Gagal mengambil data kolam.',
          icon: 'error'
        })
      })
  }
  useEffect(() => {

  const getData = () => {
    const url = apiUrl.apiUrl + '/api/v1/tambaq/system/cabang/cabang-user'
    axios
      .get(url, {
        params: {},
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(response => {
        if (response.data.success) {
          const data = response.data.data
          setListCabang(data)
        } else {
          Swal.fire({
            title: 'Pemberitahuan',
            text: response.data.message,
            icon: 'error'
          })
        }
      })

  }

  getData()
  // setListKolam(kolams)
  if (cabang == null || kolam == null) {
    if(cabang != null){
      getDataKolam(cabang.id)
    }
    setOpenDialog(true)
  } else {
    setOpenDialog(false)
  }
  // console.log(token, 'token')
}, [])

  interface FormInputs {
    syscabangId: any
  }

  const defaultValues = {
    syscabangId: '',
  }

  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors }
  } = useForm<FormInputs>({ defaultValues })

  const onSubmit = (data: any) => {
    listCabang.forEach(element => {
      if (element.id == data.syscabangId) {
        localStorage.setItem('cabang', JSON.stringify(element))
        setOpenDialogKolam(true)
        setOpenDialog(false)
      }
    });
  }

  const handleSetKolam = (data: any) => {
    localStorage.setItem('kolam', JSON.stringify(data))
    window.location.reload()
  }

  return (
    <>
      <header className={'header-component'}>
        <Toolbar className={'header-toolbar'}>
          <Item
            visible={menuToggleEnabled}
            location={'before'}
            widget={'dxButton'}
            cssClass={'menu-button'}
          >
            <Button icon="menu" stylingMode="text" onClick={toggleMenu} />
          </Item>
          <Item
            location={'before'}
            cssClass={'header-title'}
            text={title}
            visible={!!title}
          />
          <Item
            location={'before'}
          >

            {cabang == null || kolam == null ? (
              ''
            ) : (
                <div
                onClick={() => {
                  getDataKolam(cabang.id);
                  setOpenDialogKolam(true);
                }}
                style={{ cursor: 'pointer' }}
                >
                <Chip
                  size='small'
                  label={`${cabang.nama} - ${kolam.nama}`}
                  color={'primary'}
                  sx={{ ml: 1.5, '& .MuiChip-label': { px: 2.5, lineHeight: 1.385, textTransform: 'capitalize' } }}
                />
                </div>
            )}
            {/* <div>
              <Button
                stylingMode='text'
                icon={'search'}
                text={'Search'}
              onClick={toggleDialog}
              />
            </div> */}
          </Item>
          <Item
            location={'after'}
          >
            {/* <ThemeSwitcher /> */}
          </Item>
          <Item location='after' locateInMenu='auto' menuItemTemplate='userPanelTemplate'>
            <UserPanel menuMode='context' />
          </Item>
          <Template name='userPanelTemplate'>
            <UserPanel menuMode='list' />
          </Template>
        </Toolbar>
      </header>
      {/* <AutocompleteComponent open={openDialog} toggle={toggleDialog} /> */}
      <Dialog
        maxWidth={'xs'}
        fullWidth={true}
        open={openDialog}
        disableEscapeKeyDown
        aria-labelledby='form-dialog-title'
      >
        <DialogTitle id='form-dialog-title' sx={{ textAlign: 'center', fontSize: '24px !important' }}>
          Pilih Site
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', mt: 1, mb: 2 }} spacing={2}>
              <Grid item xs={12} sm={12}>
                <FormControl fullWidth>
                  <InputLabel>Pilih Site</InputLabel>
                  <Controller
                    name='syscabangId'
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { value, onChange } }) => (
                      <Select
                        label='Pilih Site'
                        value={value || ''}
                        onChange={e => {
                          onChange(e);
                          const selectedValue = e.target.value;
                          if (selectedValue !== '' && selectedValue !== null) {
                            getDataKolam(selectedValue);
                          }
                        }}
                        error={Boolean(errors.syscabangId)}
                      >
                        {listCabang.map((item, index) => (
                          <MenuItem value={item.id} key={index}>
                            {item.nama}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                  {errors.syscabangId && (
                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </Grid>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Button
                text="SIMPAN"
                type="default"
                stylingMode="contained"
                useSubmitBehavior={true}
                elementAttr={{ class: "dx-button-primary" }}
              />
            </Box>
          </form>
        </DialogContent>
      </Dialog>
      <Dialog
        maxWidth={'md'}
        fullWidth={true}
        open={openDialogKolam}
        disableEscapeKeyDown
        aria-labelledby='form-dialog-title'
      >
        <DialogTitle id='form-dialog-title' sx={{ textAlign: 'center', fontSize: '28px !important' }}>
          Pilih Kolam
        </DialogTitle>
        <DialogContent>
          <Grid container sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }} spacing={2}>
            {listKolam.map((item, index) => (
              <Grid item xs={12} sm={4} key={index}>
                <div className={'content-block dx-card'} style={{ backgroundColor: '#0A61B7', color: 'white', cursor: 'pointer' }}>
                  <CardContent>
                    <div onClick={() => handleSetKolam(item)}>
                      <Box
                        sx={{
                          flex: 1,
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <Typography variant='h4'>{item.nama}</Typography>
                      </Box>
                    </div>
                  </CardContent>
                </div>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  )
}
